import React from "react";
import TriloChatAvatar from "./TriloChatAvatar";
import { CHAT_MESSAGE_ROLE } from "../utils/triloChatConstants";

/**
 * TriloChatTypingIndicator
 *
 * Placeholder bubble shown while MW is working and has not yet reported which
 * tool it is running.
 */
const TriloChatTypingIndicator = () => (
  <div className="trilochat__message trilochat__message--assistant">
    <TriloChatAvatar role={CHAT_MESSAGE_ROLE.assistant} />
    <div className="trilochat__bubble trilochat__bubble--typing">
      <span className="trilochat__typing-dot" />
      <span className="trilochat__typing-dot" />
      <span className="trilochat__typing-dot" />
    </div>
  </div>
);

export default TriloChatTypingIndicator;
